// Shared helpers for the multi-dashboard feature. "all" is the virtual All Agents dashboard;
// every other id is a dashboard GUID.
export const ALL_DASHBOARD_ID = 'all';

export const isAllDashboard = (dashboardId) =>
	!dashboardId || String(dashboardId).toLowerCase() === ALL_DASHBOARD_ID;

export const sameDashboardId = (a, b) =>
	String(a ?? ALL_DASHBOARD_ID).toLowerCase() === String(b ?? ALL_DASHBOARD_ID).toLowerCase();

export const dashboardPath = (dashboardId) => `/dashboards/${dashboardId}`;

export const dashboardStatusesEndpoint = (dashboardId) =>
	`/api/v1.0/dashboards/${dashboardId}/agent-statuses`;

export const DASHBOARDS_ENDPOINT = '/api/v1.0/dashboards';
export const MY_DASHBOARDS_ENDPOINT = `${DASHBOARDS_ENDPOINT}/mine`;
export const DASHBOARD_USERS_ENDPOINT = `${DASHBOARDS_ENDPOINT}/users`;

// Fired after dashboards are created / renamed / deleted / re-shared so other mounted views
// (the sidebar dropdown) refetch their list.
export const DASHBOARDS_CHANGED_EVENT = 'dashboardsChanged';
export const notifyDashboardsChanged = () => window.dispatchEvent(new Event(DASHBOARDS_CHANGED_EVENT));

// True when `pathname` is one of the dashboard pages (/home redirects to one).
export const isDashboardPathname = (pathname) =>
	pathname === '/home' || pathname.startsWith('/dashboards/');

// The dashboard a user last opened on this device, so /home (and the phone's Dashboard tab) can
// return to it. Storage can be unavailable (private mode), so it is only ever a convenience.
const LAST_DASHBOARD_KEY = 'last-dashboard-id';

export const getLastDashboardId = () => {
	try {
		return window.localStorage.getItem(LAST_DASHBOARD_KEY);
	} catch {
		return null;
	}
};

export const setLastDashboardId = (dashboardId) => {
	try {
		window.localStorage.setItem(LAST_DASHBOARD_KEY, dashboardId);
	} catch {
		// ignore - remembering the last dashboard is best-effort
	}
};
